export default __webpack_public_path__ + "static/media/gallery-29.ba3056eb.jpg";